import { ChevronDown, ChevronUp } from 'lucide-react';
import { formatCurrency } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export const ExpensesItemsRollupCard = ({
  items = [],
  collapsed = false,
  onToggle,
}) => {
  if (!items.length) {
    return null;
  }

  return (
    <Card className="border-slate-200 shadow-sm" data-testid="expenses-items-rollup-card">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 py-3">
        <div>
          <CardTitle className="text-sm">Artigos comprados por loja</CardTitle>
          <CardDescription>Resumo agregado no filtro actual.</CardDescription>
        </div>
        <Button type="button" variant="ghost" size="sm" className="h-8 rounded-lg px-2" onClick={onToggle} data-testid="expenses-items-rollup-toggle">
          {collapsed ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
        </Button>
      </CardHeader>
      {!collapsed && (
        <CardContent className="space-y-2 pt-0">
          {items.map((item, index) => (
            <div key={item.key} className="flex flex-col gap-2 rounded-xl border border-slate-200 bg-slate-50/70 px-3 py-2 lg:flex-row lg:items-center lg:justify-between" data-testid={`expenses-items-rollup-row-${index}`}>
              <div className="min-w-0">
                <p className="text-sm font-semibold text-slate-950">{item.description}</p>
                <p className="text-xs text-muted-foreground">{item.location_name} · {item.documents_count} documento(s)</p>
              </div>
              <div className="flex flex-wrap gap-1.5 text-xs">
                <Badge variant="outline">Comprado: {item.quantity} {item.unit}</Badge>
                <Badge variant="outline">Aplicado: {item.used_quantity} {item.unit}</Badge>
                <Badge variant="outline">Saldo: {item.remaining_quantity} {item.unit}</Badge>
                <Badge variant="outline">{formatCurrency(item.total)}</Badge>
              </div>
            </div>
          ))}
        </CardContent>
      )}
    </Card>
  );
};